import api from './axios';

export const listar    = ()          => api.get('/tamanhos-uniforme/');
export const criar     = (data)      => api.post('/tamanhos-uniforme/', data);
export const atualizar = (id, data)  => api.patch(`/tamanhos-uniforme/${id}`, data);
